module.exports = __webpack_public_path__ + "img/onespring_logo.9a01033d.svg";